import React, { useState } from 'react';
// Modules
import Container from 'react-bootstrap/Container';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
// Context
import { CTALogsDataProvider } from '../../context/CTALogsContext';
import { CTALogClassesDataProvider } from '../../context/CTALogClassesContext';
import { CTALogTypesDataProvider } from '../../context/CTALogTypesContext';
// Components
import PageTitle from '../../components/header/PageTitle';
import CTALogList from './components/logs/CTALogList';
import CTALogElements from './components/CTALogElements';

export default function ServicesPlusLogs() {
  // State
  const [view, setView] = useState(0);

  // Constants
  const radios = [
    { name: 'CTA', value: 0 },
    { name: 'Elementos', value: 1 },
  ];

  return (
    <Container>
      <PageTitle titleText="Gestão de CTA's" />
      <ButtonGroup>
        {radios.map((radio, index) => (
          <ToggleButton
            key={index}
            id={`radio-${index}`}
            type="radio"
            name="radio"
            value={radio.value}
            checked={view === radio.value}
            onChange={() => setView(radio.value)}
          >
            {radio.name}
          </ToggleButton>
        ))}
      </ButtonGroup>
      <CTALogsDataProvider>
        <CTALogClassesDataProvider>
          <CTALogTypesDataProvider>
            {view === 0 && <CTALogList />}
            {view === 1 && <CTALogElements />}
          </CTALogTypesDataProvider>
        </CTALogClassesDataProvider>
      </CTALogsDataProvider>
    </Container>
  );
}
